import { useCurrentUserLocale } from "@app/shared/utils/currentUserLocale";
import { SupportedLocales } from "@app/shared/utils/locales";
import { Icon } from "@design-system/Icon";
import { Button } from "@design-system/Inputs/Button";
import { Calendar } from "@design-system/Inputs/Calendar";
import { Text } from "@design-system/Typography/Text";
import { cn } from "@design-system/Utilities";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@radix-ui/react-popover";
import { format } from "date-fns";
import { type FC } from "react";

export const DateInput: FC<{
    date?: Date;
    setDate: (date?: Date) => void;
    placeholder?: string;
    disablePast?: boolean;
}> = ({ date, setDate, placeholder, disablePast }) => {
    const userLocale = useCurrentUserLocale(SupportedLocales.EN);

    return (
        <Popover>
            <PopoverTrigger
                className="w-full flex items-stretch justify-stretch"
                asChild
            >
                <Button
                    variant="text"
                    className={cn(
                        "w-full min-h-8",
                        "px-4",
                        "font-normal text-primary",
                        "border border-tertiary",
                        "hover:bg-transparent hover:shadow-none",
                        "rounded-lg",
                    )}
                >
                    {date ? (
                        format(date, "PPP")
                    ) : (
                        <Text as="span" color="secondary">
                            {placeholder}
                        </Text>
                    )}
                    <Icon name="calendar" />
                </Button>
            </PopoverTrigger>
            <PopoverContent
                align="start"
                alignOffset={-2}
                sideOffset={9}
                className="absolute transform -translate-x-3 shadow-lg bg-white"
            >
                <Calendar
                    mode="single"
                    defaultMonth={date ? new Date(date) : new Date()}
                    selected={date}
                    onSelect={setDate}
                    locale={{ code: userLocale }}
                    required={false}
                    className="rounded-md border"
                    disabled={disablePast ? { before: new Date() } : undefined}
                />
            </PopoverContent>
        </Popover>
    );
};
